import { render, staticRenderFns } from "./AllSupplierProductsList.vue?vue&type=template&id=5c754344&"
import script from "./AllSupplierProductsList.vue?vue&type=script&lang=js&"
export * from "./AllSupplierProductsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports